import { HTMLAttributes, DetailedHTMLProps, FC, ReactNode } from 'react'
import { Memo } from '@/hoc/Memo'
import { cn } from '@bem-react/classname'

import './Block.scss'

const cnBack = cn('Block')

export type BlockType = 'info' | 'warning' | 'default' | 'error'

export interface BlockSchema
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children: ReactNode
  type?: BlockType
}

export const Block: FC<BlockSchema> = Memo(
  ({ children, className, type }: BlockSchema) => {
    return (
      <div
        className={cnBack(
          {
            info: type === 'info',
            warning: type === 'warning',
            default: type === 'default',
            error: type === 'error',
          },
          [className],
        )}
      >
        {children}
      </div>
    )
  },
)
